import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/organisaties/$organizationId/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "organizations"),
})

function RouteComponent() {
  return (
    <div className="flex items-center justify-center h-full">
      <p className="text-gray-500">
        Selecteer een item in de zijbalk om details te bekijken
      </p>
    </div>
  )
}
